import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, formatError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { GoogleLogo, Envelope, LockKey } from "@phosphor-icons/react";

export default function Login() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data.user);
      toast.success("Bem-vindo de volta!");
      navigate("/");
    } catch (err) {
      toast.error(formatError(err.response?.data?.detail) || "Erro ao entrar");
    } finally {
      setLoading(false);
    }
  }

  function googleLogin() {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  }

  return (
    <div className="pt-16 min-h-screen flex items-center justify-center px-5 py-10 hero-grad">
      <div className="w-full max-w-md bg-[#121217] border border-white/5 rounded-2xl p-8 fadeup" data-testid="login-card">
        <div className="font-mono-accent text-xs text-[#E63946] mb-2">◢ ENTRAR</div>
        <h1 className="font-display text-3xl font-bold tracking-tight">Bem-vindo de volta</h1>
        <p className="text-sm text-zinc-400 mt-2">Entra para gerir a tua coleção e participar na comunidade.</p>

        <Button
          type="button"
          onClick={googleLogin}
          variant="outline"
          className="w-full mt-6 bg-white text-zinc-900 hover:bg-zinc-100 border-0"
          data-testid="google-login-btn"
        >
          <GoogleLogo size={20} weight="bold" className="mr-2" /> Continuar com Google
        </Button>

        <div className="my-6 flex items-center gap-4">
          <div className="flex-1 h-px bg-white/10" />
          <div className="font-mono-accent text-[10px] text-zinc-500">OU EMAIL</div>
          <div className="flex-1 h-px bg-white/10" />
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <div className="relative mt-1">
              <Envelope size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-500" />
              <Input
                id="email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="pl-9 bg-[#1C1C22] border-white/10"
                data-testid="login-email-input"
              />
            </div>
          </div>
          <div>
            <Label htmlFor="password">Palavra-passe</Label>
            <div className="relative mt-1">
              <LockKey size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-500" />
              <Input
                id="password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="pl-9 bg-[#1C1C22] border-white/10"
                data-testid="login-password-input"
              />
            </div>
          </div>
          <Button type="submit" disabled={loading} className="w-full btn-crimson" data-testid="login-submit-btn">
            {loading ? "A entrar..." : "Entrar"}
          </Button>
        </form>

        <p className="text-sm text-zinc-400 mt-6 text-center">
          Não tens conta?{" "}
          <Link to="/registar" className="text-[#E63946] hover:underline" data-testid="goto-register-link">
            Regista-te
          </Link>
        </p>
      </div>
    </div>
  );
}
